import React from 'react';
import { textPrimary } from '@osmosis/tailwind-ui/styles/text';
import { bg0, bg1, bg2 } from '@osmosis/tailwind-ui/styles/background';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { H4 } from '@osmosis/tailwind-ui/components/Text';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';

type Props = {
  icon: IconDefinition;
  heading: string;
  subheading: string;
  disabled?: boolean;
  onClick: () => void;
  ['data-testid']?: string;
};

/**. */
/* eslint-disable jsdoc/require-jsdoc */
const VideoNextUpItem = (props: Props) => {
  const { icon, heading, subheading, onClick, disabled = false } = props;

  const hoverBg = `hover:${bg1}`;
  const activeBg = `active:${bg2}`;
  return (
    <Flex
      data-testid={props['data-testid']}
      onClick={disabled ? undefined : onClick}
      className={`px-3 py-2 cursor-pointer ${bg0} ${hoverBg} ${activeBg} transition-all duration-100 ease-in-out gap-2 rounded-[5px]`}
    >
      <Box className={`text-lg md:text-3xl ${textPrimary}`}>
        <Icon icon={icon} />
      </Box>

      <Flex className="flex-col">
        <H4>{heading}</H4>
        <P className="hidden md:block">{subheading}</P>
      </Flex>
    </Flex>
  );
};

export default VideoNextUpItem;
